import { SchoolSurveyStats } from '../../services/surveyService';
import { calculateResponseRate, getResponseRateColor } from './utils';
import './SchoolResponseTable.css';

interface SchoolResponseTableProps {
  schools: SchoolSurveyStats[];
}

const SchoolResponseTable = ({ schools }: SchoolResponseTableProps) => {
  const sortedSchools = [...schools].sort((a, b) => a.school_name.localeCompare(b.school_name));

  return (
    <table className="school-response-table">
      <thead>
        <tr>
          <th>School</th>
          <th>Response rate in %</th>
        </tr>
      </thead>
      <tbody>
        {sortedSchools.map((school) => {
          const rate = calculateResponseRate(school.submission_count, school.expected_count);
          const color = getResponseRateColor(rate);
          return (
            <tr key={school.school_id}>
              <td>{school.school_name}</td>
              <td className="school-response-table-rate-cell">
                <span className="school-response-table-rate-badge" style={{ backgroundColor: color }}>
                  {rate !== null ? rate : 'N/A'}
                </span>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default SchoolResponseTable;
